// Default import-wizard options. The live config is loaded from the API and editable in admin.
const DEFAULT_WIZARD_CONFIG = {
  brands: ["Tesla", "BMW", "Audi", "Polestar", "Porsche", "Mercedes", "Volkswagen", "Hyundai", "Kia"],
  models: {
    Tesla: ["Model S", "Model 3", "Model X", "Model Y", "Cybertruck"],
    BMW: ["i3", "iX3", "iX", "i4", "i7"],
    Audi: ["e-tron", "e-tron GT", "Q4 e-tron", "Q8 e-tron"],
    Polestar: ["Polestar 2", "Polestar 3", "Polestar 4"],
    Porsche: ["Taycan", "Taycan Sport Turismo", "Taycan Cross Turismo"],
    Mercedes: ["EQA", "EQB", "EQC", "EQE", "EQS"],
    Volkswagen: ["ID.3", "ID.4", "ID.5", "ID.7", "ID. Buzz"],
    Hyundai: ["IONIQ 5", "IONIQ 6", "Kona Electric"],
    Kia: ["EV6", "EV9", "Niro EV"],
  },
  yearCount: 6,
  colors: ["Bílá", "Černá", "Stříbrná", "Modrá", "Červená", "Šedá", "Zelená", "Oranžová", "Žlutá", "Bez preference"],
  mileages: ["10,000–30,000 km", "30,000–60,000 km", "60,000–100,000 km", "100,000–150,000 km", "150,000+ km", "Bez preference"],
  priceTiers: [
    { label: "Budget", range: "do 400 000 Kč", desc: "Skvělá hodnota s dobrým dojezdem", color: "#00ff88" },
    { label: "Mid-Range", range: "400 000 – 600 000 Kč", desc: "Prémiové funkce, výborný výkon", color: "#00e5ff" },
    { label: "Luxury", range: "600 000 Kč +", desc: "Špičkový luxus a výkon", color: "#7c4dff" },
  ],
  contactEmail: "info@VoltNaPrani.cz",
  wizardTitle: "Individuální dovoz elektromobilu na míru",
  wizardSubtitle: "Zajistíme dovoz aut ze zahraničí přesně dle vašich požadavků — řekněte nám co hledáte a my zajistíme dovoz EV z celé EU.",
};

export default DEFAULT_WIZARD_CONFIG;
